// import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { IMyScriptInjectorViewProps } from './my-script-injector';

export default (props: IMyScriptInjectorViewProps) => {
    // const scriptContents = `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;ga('create', 'UA-XXXXX-Y', 'auto');ga('send', 'pageview')`;
    // const IS_PROD_ENV = process.env.IS_PROD_ENV;
    return (
        // <HtmlHeadInclude>
        //     {parseInt(IS_PROD_ENV || '', 10) === 1 ? (
        //         <script
        //             data-load-point='headStart'
        //             src='//assets.adobedtm.com/05064fe6cab0/b9d37f296ace/launch-fe44d8adbb98.min.js'
        //             async
        //         ></script>
        //     ) : (
        //         <script
        //             data-load-point='headStart'
        //             src='//assets.adobedtm.com/05064fe6cab0/b9d37f296ace/launch-da2183d7ff8b-development.min.js'
        //             async
        //         ></script>
        //     )}
        // </HtmlHeadInclude>
        <></>
    );
};
